<template>
    <!-- <b-list-group-item v-for="invite in invites" :key="invite.accountInviteId" class="flex-column align-items-start"> -->
    <b-list-group-item class="flex-column align-items-start" >
        <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">{{roleName}} @ {{targetName}}</h5>
            <small v-if="!resolved">{{ invite.inviteCreation | moment("from") }}</small>
        </div>

        <p class="mb-1">
        This invite grants <strong>{{roleName}}</strong> access to <strong>{{targetName}}</strong>.
        </p>

        <div v-if="!resolved" class="d-flex w-100 justify-content-between">
            <small>Invite expires {{invite.inviteExpiration | moment("from")}}</small>
            <div v-if="!loading">
                <b-button size="sm" variant="outline-primary" @click="accept">Accept</b-button>
                <b-button v-if="showReject" size="sm" variant="outline-danger" @click="reject">Reject</b-button>
            </div>
            <div v-else><b-spinner></b-spinner></div>
        </div>
        <div v-else class="d-flex w-100 justify-content-between">
          <div v-if="!rejected" >
<!--            <div v-if="showCountdown">-->
<!--              <div>-->
<!--                <small>(Permissions may take up to {{secondsRequired}} seconds to apply)</small>-->
<!--              </div>-->
<!--              <div v-if="secondsRemaining !== undefined">-->
<!--                <div v-if="secondsRemaining > 0">-->
<!--                  <small>Ready in: {{secondsRemaining}} second(s)</small>-->
<!--                </div>-->
<!--                <div v-else>-->
<!--                  <b-button size="sm" variant="outline-primary" @click="goNow">Go Now</b-button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div v-else>-->
<!--              <small>This invite has been accepted!</small>-->
<!--            </div>-->
            <div>
              <b-button size="sm" variant="outline-primary" @click="goNow">Go Now</b-button>
            </div>
            <div>
              <small>This invite has been accepted!</small>
            </div>
          </div>
          <div v-else>
            <small>This invite has been rejected!</small>
          </div>
        </div>
    </b-list-group-item>
</template>
<script>
import { UserInviteResolutionRequest } from '#/protobuf/service_user_pb';

export default {
  components: {
  },
  props: {
    invite: {
      type: Object, // corresponds to an AccountInviteMessage
      required: true,
    },
    showReject: {
      type: Boolean,
      default: true,
    },
    showCountdown: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      resolved: false,
      rejected: false,
      loading: false,
      secondsRequired: 15,
      secondsRemaining: undefined, // used for the countdown timer after accept
      acceptedTimer: undefined, // a timer that is set only after successfully accepting an invite to await granting access.
    };
  },
  created() {
  },
  computed: {
    roleName() {
      return this.invite.projectRoleName ? this.invite.projectRoleName : this.invite.accountRoleName;
    },
    targetName() {
      return this.invite.projectName ? this.invite.projectName : this.invite.accountName;
    },
  },
  methods: {
    async accept() {
      console.log('accepting invite');
      return this.finalizeInvite(true);
    },
    async reject() {
      console.log('rejecting invite');
      this.rejected = true;
      return this.finalizeInvite(false); // false to reject invite
    },
    async goNow() {
      // route to project if for project, else account
      if (this.invite.projectId) {
        this.$router.push({ path: '/home/', query: { project: this.selectedProject } });
      } else {
        // TODO: this isn't the best account page to reroute too, probably need an account overview page.

        if (this.invite.accountId) {
          this.$store.dispatch('initialLoad').then(() => {
            this.$router.push({ path: `/workspace/${this.invite.accountId}` });
          });
        } else {
          console.warn('COULD NOT GET ACCOUNT from invite');
          // TODO: show user error here?
        }
      }
    },
    async finalizeInvite(shouldAccept = true) {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      const request = new UserInviteResolutionRequest();
      request.setAccountInviteId(this.invite.accountInviteId);
      request.setAcceptInvite(shouldAccept);
      return this.$store.dispatch('user/resolveInvite', request).then((response) => {
        console.log('resolved invite', response);
        if (shouldAccept) {
          this.beginTimer();
        } else {
          this.$emit('remove-user-invite', this.invite.accountInviteId);
        }
        this.resolved = true;
        // TODO: include whether accepted / rejected in response
      }).catch((error) => {
        console.log('error attempting to resolve invite', error.message);
      }).finally(() => {
        this.loading = false;
      });
    },
    beginTimer() {
      // fire this function to transition the gui into a countdown mode while awaiting the permissions to propogate in the backend.
      if (this.secondsRemaining !== undefined) {
        return;
      }
      console.info('awaiting permissions propogation...');
      this.secondsRemaining = this.secondsRequired;
      this.acceptedTimer = setInterval(() => {
        if (this.secondsRemaining > 0) {
          this.secondsRemaining -= 1;
        }
      }, 1000);
    },
  },
  beforeDestroy() {
    clearInterval(this.acceptedTimer);
    this.acceptedTimer = undefined;
  },
};
</script>
<style>

</style>
